import React from "react";
import { Routes, Route } from "react-router-dom";
import Banner from "./components/Banner";
import { EnquiryModalProvider } from "./components/EnquiryModal";
import CardPage from "./components/PricingCardPage";
import "./App.css";
import ThankYouPage from "./components/ThankyouPage";
import PrivacyPolicy from "./components/PrivacyPolicy";


function App() {
  return (
    <EnquiryModalProvider>
      {/* <AppContent /> */}
      {/* <Router> */}
        <Routes>
          <Route path="/" element={<Banner />} />
          <Route path="/property/:id" element={<CardPage />} />
          <Route path="/thankyou.html" element={<ThankYouPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      {/* </Router>/ */}
    </EnquiryModalProvider>
  );
}

export default App;
